export const validateAndRemoveNumbers = (data) => {
    return data.replace(/\d/g, '');
};
const validateMoreThanOneWord = (data) => {
    return data.trim().split(' ').length > 1;
};
const validateLength = (data) => {
    const names = data.trim().split(' ');
    return names[0].length >= 3;
};
export function isValidFullName(value) {
    if (!value)
        return false;
    return validateLength(value) && validateMoreThanOneWord(value);
}
